import Axios from 'axios';
import { config, SERVER_URL } from '../environment/env_dev';

export const getTransactions = () => {
    return Axios.get(`${SERVER_URL}/api/Transactions`, config);
};
